// mirrors pdf.js MIN_SCALE/MAX_SCALE — the package does not export them
export const PDF_VIEWER_MIN_SCALE = 0.1

export const PDF_VIEWER_MAX_SCALE = 25

export const PDF_VIEWER_PAGE_WIDTH_CSS_VARIABLE = '--pdf-viewer-page-width'
